import Grid from '@mui/material/Unstable_Grid2';
import { Bus } from '../../@types/contractors';
import { useProvideSnackBar } from '../../hooks';

import { BusCard } from './BusCard';
import { IconButton } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

interface BusCardsProps {
    onAddBusCard: () => void;
    busList: Bus[];
    setBusList: (list: Bus[]) => void;
}

export default function BusCards({ onAddBusCard, busList, setBusList }: BusCardsProps) {
    const { showError } = useProvideSnackBar();

    const handleIsCardsData = () => {
        const allCardsHaveValues = busList.every(bus => {
            return bus.Manufacturer !== '' && bus.Type !== '' && bus.YearOfManufacture !== '' && bus.Capacity !== 0;
        });

        if (!allCardsHaveValues) {
            showError('Kérjük, töltse ki az összes busz adatot!');
        }
        return allCardsHaveValues;
    };

    const handleAddBusCardWithCheck = () => {
        if (handleIsCardsData()) {
            onAddBusCard();
        }
    };

    return (
        <Grid container spacing={1} sx={{ justifyContent: 'center', alignItems: 'center' }}>
            {busList.map((bus, index) => (
                <BusCard
                    bus={bus}
                    index={index}
                    onDelete={id => setBusList(busList.filter(b => b.ID !== id))}
                    onUpdate={bus => {
                        const busListCopy = busList.map(b => {
                            if (b.ID !== bus.ID) {
                                return b;
                            }
                            return bus;
                        });
                        setBusList(busListCopy);
                    }}
                    key={index}
                />
            ))}
            <Grid xs={1}>
                <IconButton title='Busz hozzáadása' onClick={handleAddBusCardWithCheck} color='primary'>
                    <AddCircleOutlineIcon sx={{ fontSize: 68 }} />
                </IconButton>
            </Grid>
        </Grid>
    );
}
